import { render, staticRenderFns } from "./DailyReportofCall.vue?vue&type=template&id=5c5302c5"
import script from "./DailyReportofCall.vue?vue&type=script&lang=js"
export * from "./DailyReportofCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports